<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="device-roam">
      <div class="device-roam-top">
        <p class="device-roam-top-title">设备使用信息</p>
        <img
          class="device-roam-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="device-roam-middle">
        <!-- 第一行：设备属性 + 设备状态 -->
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">设备属性：</p>
            <el-select
              v-model="deviceAttribute"
              placeholder="试用"
              class="form-field-select"
              disabled
            >
              <el-option label="试用" :value="2"></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">设备状态：</p>
            <el-select
              v-model="deviceStatus"
              placeholder="流转中"
              class="form-field-select"
              disabled
            >
              <el-option label="流转中" :value="3"></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第二行：负责人 + 换绑关联机构 -->
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>负责人：</p>
            <el-select
              v-model="outboundPersonId"
              placeholder="请选择负责人"
              class="form-field-select"
              filterable
              :disabled="isPersonFieldDisabled"
            >
              <el-option
                v-for="person in personList"
                :key="person.value"
                :label="person.label"
                :value="person.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title"><span class="required">*</span>换绑关联机构：</p>
            <el-select
              v-model="outboundHospitalId"
              placeholder="请选择机构"
              class="form-field-select"
              filterable
            >
              <el-option
                v-for="hospital in hospitalList"
                :key="hospital.value"
                :label="hospital.label"
                :value="hospital.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第三行：同步处理指环1 + 同步处理指环2（仅ZG-S01D设备型号显示） -->
        <div class="form-row" v-if="shouldShowRings">
          <div class="form-field">
            <p class="form-field-title">同步处理指环：</p>
            <el-select
              v-model="outboundRing1"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              clearable
            >
              <el-option
                v-for="ring in ringList"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">同步处理指环：</p>
            <el-select
              v-model="outboundRing2"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              clearable
            >
              <el-option
                v-for="ring in ringList"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        
        <!-- 文案提示区域 -->
        <div class="form-tips">
          <p class="form-tips-title">解除原来之间的关联关系并同时切换到新选择的机构（未选择 则为空）：</p>
          <div class="form-tips-content">
            <p v-if="deviceData">
              <span v-if="deviceData.deviceHospitalName">
                {{ deviceData.model }}（sn：{{ deviceData.deviceSn || '--' }}）与{{ deviceData.deviceHospitalName }}
              </span>
              <span v-else>
                {{ deviceData.model }}（sn：{{ deviceData.deviceSn || '--' }}）不存在 机构关联信息
              </span>
            </p>
            <p v-for="ring in allRingTips" :key="ring.id">
              指环（sn：{{ ring.deviceSn || '--' }}）与{{ ring.hospitalName || '未知机构' }}
            </p>
          </div>
        </div>
      </div>
      <div class="device-roam-bottom">
        <button class="device-roam-bottom-cancel" @click="onCancelClick">取消</button>
        <button class="device-roam-bottom-confirm" @click="onConfirmClick">确定</button>
      </div>
    </div>
  </pop-view>
</template>

<script>
import PopView from "@c/common/pop-view.vue";
import { Select, Option } from "element-ui";

export default {
  components: {
    PopView,
    ElSelect: Select,
    ElOption: Option,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    },
    hospitalList: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    return {
      deviceAttribute: 2, // 固定为试用
      deviceStatus: 3, // 固定为流转中
      outboundRing1: null,
      outboundRing2: null,
      outboundPersonId: null,
      outboundHospitalId: null,
      personList: [],
      ringList: [],
    };
  },

  computed: {
    // 判断是否显示指环选择（仅ZG-S01D设备型号）
    shouldShowRings() {
      return this.deviceData && this.deviceData.model === 'ZG-S01D';
    },

    // 判断负责人字段是否禁用（销售经理时禁用）
    isPersonFieldDisabled() {
      return this.$store.getters.isSalesManager;
    },

  

    // 获取初始化的指环关联信息（来自syncOutboundRingHospitals）
    initialRingTips() {
      const tips = [];
      if (this.deviceData && this.deviceData.syncOutboundRingHospitals && Array.isArray(this.deviceData.syncOutboundRingHospitals)) {
        this.deviceData.syncOutboundRingHospitals.forEach(ringData => {
          tips.push({
            id: ringData.id,
            deviceSn: ringData.ringSn || '--',
            hospitalName: ringData.hospitalName || '未知机构'
          });
        });
      }
      return tips;
    },

    // 获取选中的指环提示信息（选择新指环时）
    selectedRingTips() {
      const tips = [];
      if (this.outboundRing1) {
        const ring1 = this.ringList.find(ring => ring.value === this.outboundRing1);
        if (ring1) {
          tips.push({
            id: ring1.value,
            deviceSn: ring1.deviceSn || ring1.label, // 使用deviceSn字段
            hospitalName: ring1.deviceHospitalName || '未知机构' // 使用deviceHospitalName字段
          });
        }
      }
      if (this.outboundRing2) {
        const ring2 = this.ringList.find(ring => ring.value === this.outboundRing2);
        if (ring2) {
          tips.push({
            id: ring2.value,
            deviceSn: ring2.deviceSn || ring2.label, // 使用deviceSn字段
            hospitalName: ring2.deviceHospitalName || '未知机构' // 使用deviceHospitalName字段
          });
        }
      }
      return tips;
    },

    // 显示的指环信息：如果有选中的指环则显示选中的，否则显示初始的
    allRingTips() {
      // 如果用户选择了新指环，则显示新选择的指环，替换原有的
      if (this.selectedRingTips.length > 0) {
        return this.selectedRingTips;
      }
      // 否则显示初始的指环信息
      return this.initialRingTips;
    }
  },

  async mounted() {
    await this.getPersonList();
    await this.getRingList();
    this.initializeRingSelections();
    console.log('deviceData',this.deviceData)
  },

  methods: {
    async getPersonList() {
      try {
        // 获取负责人列表
        const response = await this.$api.getResponsiblePersonList();
        this.personList = response.map(item => ({
          value: item.id,
          label: item.trueName
        }));
      } catch (error) {
        console.error('获取负责人列表失败:', error);
      }
    },

    async getRingList() {
      try {
        // 获取同步处理指环列表：deviceStatus=3, deviceNature=2
        const response = await this.$api.getRingDeviceList({
          deviceStatus: 3,
          deviceNature: 2
        });
        this.ringList = response.map(item => ({
          value: item.id,
          label: item.deviceSn,
          deviceSn: item.deviceSn, // 保存设备SN
          deviceHospitalName: item.deviceHospitalName // 保存原关联机构名称
        }));
      } catch (error) {
        console.error('获取指环列表失败:', error);
      }
    },

    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    onCancelClick: function () {
      this.onCloseClick();
    },

    onConfirmClick() {
      // 验证必填字段
      if (!this.outboundPersonId) {
        this.$toast.showRed("请选择负责人");
        return;
      }
      if (!this.outboundHospitalId) {
        this.$toast.showRed("请选择换绑关联机构");
        return;
      }

      // 验证两个同步处理指环值不能相同
      if (this.outboundRing1 && this.outboundRing2 && this.outboundRing1 === this.outboundRing2) {
        this.$toast.showRed("两个同步处理指环值需要不相同");
        return;
      }

      // 合并指环选择
      const outboundRingIds = [this.outboundRing1, this.outboundRing2].filter(ring => ring !== null);

      // 只传递参数给父组件，由父组件负责调用接口
      const params = {
        deviceAttribute: this.deviceAttribute,
        deviceStatus: this.deviceStatus,
        outboundRingIds: outboundRingIds.join(','),
        outboundPersonId: this.outboundPersonId,
        outboundHospitalId: this.outboundHospitalId,
      };

      this.$emit("onConfirmClick", params);
    },

    initializeRingSelections() {
      // 初始化负责人选择
      console.log('personList',this.personList)
      if (this.deviceData && this.deviceData.outboundPersonId) {
        // 在personList中查找匹配的负责人
       
        const matchedPerson = this.personList.find(person => person.value === this.deviceData.outboundPersonId);
        if (matchedPerson) {
          this.outboundPersonId = matchedPerson.value;
        }
      }

      // 初始化换绑关联机构选择
      if (this.deviceData) {
        // 如果outboundHospitalName有值，使用outboundHospitalId
        if (this.deviceData.outboundHospitalName) {
          this.outboundHospitalId = this.deviceData.outboundHospitalId;
        } else {
          // 如果outboundHospitalName没有值，使用deviceHospitalId
          this.outboundHospitalId = this.deviceData.deviceHospitalId;
        }
      }

      // 如果deviceData中有syncOutboundRingHospitals且是数组
      if (this.deviceData && 
          this.deviceData.syncOutboundRingHospitals && 
          Array.isArray(this.deviceData.syncOutboundRingHospitals)) {
        
        const ringHospitals = this.deviceData.syncOutboundRingHospitals;
        
        // 遍历ringHospitals，匹配到ringList中对应的项目
        ringHospitals.forEach((ringData, index) => {
          if (ringData.ringSn) {
            // 在ringList中查找匹配的指环
            const matchedRing = this.ringList.find(ring => ring.deviceSn === ringData.ringSn);
            if (matchedRing) {
              // 根据索引分配到对应的选择框
              if (index === 0) {
                this.outboundRing1 = matchedRing.value;
              } else if (index === 1) {
                this.outboundRing2 = matchedRing.value;
              }
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.device-roam {
  width: rem(550);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  &-middle {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    line-height: rem(20);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    width: 100%;
    max-height: rem(600);
    overflow-y: auto;
    padding: rem(20) rem(24);
    box-sizing: border-box;

    .required {
      color: #ff4d4f;
    }

    // 创建行容器
    .form-row {
      display: flex;
      gap: rem(20);
      margin-bottom: rem(16);

      .form-field {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: rem(8);

        &-title {
          font-weight: 500;
          margin: 0;
        }

        &-select {
          ::v-deep .el-input {
            height: rem(32);
          }
        }
      }
    }
  }

  &-bottom {
    width: 100%;
    height: rem(73);
    box-sizing: border-box;
    padding-top: rem(10);
    padding-right: rem(16);
    display: flex;
    justify-content: flex-end;

    &-confirm {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-cancel {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  // 文案提示区域样式
  .form-tips {
    margin-top: rem(20);
    padding: rem(12) rem(16);
    background-color: #f6f8fa;
    border: rem(1) solid #e1e4e8;
    border-radius: rem(4);
    color: rgba($color: black, $alpha: 0.65);
    font-size: rem(12);
    line-height: rem(18);

    &-title {
      margin: 0 0 rem(8) 0;
      font-weight: 500;
      color: rgba($color: black, $alpha: 0.85);
    }

    &-content {
      p {
        margin: 0 0 rem(4) 0;
        padding-left: rem(12);
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>